import React from 'react';
import { Grid, Typography, Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const Success = () => {
	const { t } = useTranslation();
	return (
		<div>
			<Container>
				{/* <Grid
					container
					justify='center'
					alignItems='center'
					style={{ height: '15vh' }}
				>
					<Grid item xs={12} sm={12} md={12}>
						<Typography variant='h5' style={{ textAlign: 'center' }}>
							{sessionStorage.getItem('accountMessage')
								? sessionStorage.getItem('accountMessage')
								: t('register-success')}
						</Typography>
					</Grid>
				</Grid> */}
				<Grid
					container
					direction='column'
					alignItems='center'
					justifyContent='center'
					style={{ height: '80vh' }}
				>
					<Grid item xs={12} sm={12} md={6}>
						<CheckCircleOutlineIcon
							style={{
								fontSize: '5em',
								color: '#198754',
								margin: 'auto',
								display: 'block',
							}}
						/>
						<h5 className='text-center'>
							{sessionStorage.getItem('accountMessage')
								? sessionStorage.getItem('accountMessage')
								: t('register-success')}
						</h5>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Success;
